// extracted by mini-css-extract-plugin
module.exports = {"carrierWrapper":"ClientInsurance_carrierWrapper__3TLPG","title":"ClientInsurance_title__1zKJc","itemText":"ClientInsurance_itemText__1ZEzq"};